import React, { useEffect, useState } from "react";

const BookingsList = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
const API_URL = process.env.REACT_APP_API_URL;
  useEffect(() => {
    fetchBookings();
  }, []);

  const fetchBookings = async () => {
    try {
      const res = await fetch(`${API_URL}/api/bookings`);
      const data = await res.json();
      setBookings(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const filtered = bookings.filter(
    (b) =>
      b.FullName?.toLowerCase().includes(search.toLowerCase()) ||
      b.Hall?.toLowerCase().includes(search.toLowerCase())
  );

  if (loading) {
    return <div className="text-center mt-10">Loading bookings...</div>;
  }

  return (
    <div className="max-w-7xl mx-auto bg-white shadow-2xl rounded-3xl p-8">
      <h2 className="text-3xl font-bold mb-6 text-center">
        All Bookings
      </h2>

      <input
        type="text"
        placeholder="Search by name or hall..."
        className="w-full mb-6 px-4 py-3 border rounded-xl focus:ring-2 focus:ring-emerald-500"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-sm">
          <thead>
            <tr className="bg-gradient-to-r from-blue-600 to-emerald-500 text-white">
              <th className="p-3">Name</th>
              <th>Date</th>
              <th>Hall</th>
              <th>Guests</th>
              <th>Total</th>
              <th>Advance</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((b) => (
              <tr
                key={b.Id}
                className="border-b hover:bg-emerald-50 transition"
              >
                <td className="p-3 font-semibold">{b.FullName}</td>
                <td>
                  {new Date(b.EventDate).toLocaleDateString()}
                </td>
                <td>{b.Hall}</td>
                <td>{b.Guests}</td>
                <td>₹{b.TotalAmount}</td>
                <td>₹{b.AdvanceAmount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {filtered.length === 0 && (
        <p className="text-center mt-6 text-gray-500">
          No bookings found.
        </p>
      )}
    </div>
  );
};

export default BookingsList;